import React from "react";

import Typography from "@mui/material/Typography";

import {COLORS} from "../../../../../../../config/constants";
type Props = {
  item: SupportRequest
}

const REQUEST_ID_COLOR = COLORS.BLACK;

const RequestId = ({item}: Props) => (
  <Typography
    variant='body2'
    style={{color: REQUEST_ID_COLOR}}
    sx={{letterSpacing: 0, lineHeight: '20px'}}
  >
    {item.id}
  </Typography>
);

export default RequestId;
